var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 29,
    viewBox: "0 0 161 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.6 8.08877V24.1649H151.048V8.08877H144.825V4.98071H160.5V8.08877H154.6Z",
    fill: "url(#paint0_linear_1552_58263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.593 12.8259H140.389V15.9125H130.593V20.9926H141.552V24.1435H127.47V12.8259H130.593ZM127.47 8.13164V4.98071H141.552V8.13164H127.47Z",
    fill: "url(#paint1_linear_1552_58263)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.353 24.1649L114.681 17.1986H110.353L110.31 24.1649H107.188V4.98068H115.671C116.727 4.95925 117.803 5.08786 118.815 5.38795C119.633 5.62373 120.387 6.00956 121.054 6.524C121.636 6.99556 122.109 7.61718 122.389 8.32453C122.691 9.07475 122.841 9.88927 122.841 10.7038C122.841 11.3683 122.734 12.0328 122.518 12.6758C122.325 13.2546 122.023 13.7904 121.636 14.262C121.248 14.7336 120.796 15.1194 120.279 15.4195C119.762 15.741 118.535 15.9553 117.932 16.1054L123.315 24.1649H119.353ZM119.353 10.8753C119.353 9.93214 119.052 9.09618 118.428 8.62462C117.803 8.15305 116.942 8.003 115.801 8.003H110.31V14.262H115.908C116.425 14.262 116.963 14.1977 117.459 14.0476C117.846 13.919 118.212 13.7261 118.535 13.4475C118.815 13.1902 119.03 12.8687 119.16 12.5258C119.289 11.9685 119.353 11.4112 119.353 10.8753Z",
    fill: "url(#paint2_linear_1552_58263)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4535 21.0784C96.3147 21.0569 97.1545 20.9498 97.9942 20.7783C99.0062 20.4782 100.513 19.3207 100.858 18.9134C101.31 19.2993 102.839 20.6282 103.312 21.0998C102.86 21.7429 102.494 22.0215 101.805 22.5145C101.052 23.0289 100.233 23.4362 99.3722 23.7149C98.4248 24.015 96.7454 24.165 95.475 24.165C93.9894 24.1864 92.5252 23.9506 91.1257 23.4362C89.9845 23.0075 88.951 22.3216 88.1113 21.4213C87.2931 20.5425 86.6902 19.4922 86.3242 18.3561C85.9151 17.1129 85.7213 15.8054 85.7428 14.4764C85.7213 13.1475 85.9151 11.8185 86.3242 10.5324C86.6687 9.41779 87.2716 8.38891 88.0898 7.53152C88.9295 6.67412 89.9415 6.03107 91.0611 5.62381C92.2668 5.17368 94.2477 4.95933 95.8626 4.95933C96.9822 4.93789 98.0803 5.0665 99.1569 5.34516C100.018 5.5595 100.858 5.9239 101.611 6.4169C102.279 6.8456 102.86 7.40291 103.312 8.06739C102.645 8.56039 101.396 9.78218 100.858 10.1894C100.384 9.69644 99.8459 9.28918 99.243 8.98909C97.9296 8.36748 96.5085 8.04595 95.0444 8.08882C94.097 8.13169 93.1496 8.34604 92.2453 8.66757C91.5563 8.94622 90.9534 9.39635 90.4797 9.97509C90.006 10.511 89.6615 11.154 89.4678 11.8399C89.2524 12.6973 89.1448 13.5976 89.1448 14.4979C89.1448 15.3981 89.2524 16.2984 89.4678 17.1558C89.6615 17.906 90.006 18.6134 90.4797 19.235C90.9534 19.8351 91.5563 20.2853 92.2453 20.6068C92.9558 20.9069 94.463 21.0784 95.4535 21.0784Z",
    fill: "url(#paint3_linear_1552_58263)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6924 12.8259H80.4892V15.9125H70.6924V20.9926H81.6303V24.1435H67.5703V12.8259H70.6924ZM67.5703 8.13164V4.98071H81.6518V8.13164H67.5703Z",
    fill: "url(#paint4_linear_1552_58263)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.221 18.592C63.1994 20.1567 62.4674 21.6357 61.2616 22.6431C60.6157 23.1576 60.185 23.5005 59.13 23.7792C58.075 24.0793 56.9984 24.2079 55.9003 24.1865C52.4122 24.1007 50.3021 22.8361 48.515 21.6571C48.7949 21.1427 50.0868 19.0206 50.216 18.8063C50.9696 19.1921 52.3261 20.371 54.5007 20.864C55.1467 21.0141 57.106 21.3785 58.6563 20.6711C59.4099 20.3282 59.7329 19.6637 59.7329 18.8063C59.7544 18.3562 59.6037 17.906 59.3022 17.5631C58.9577 17.2201 58.5702 16.9629 58.1396 16.77C57.6659 16.5556 52.5199 15.0981 51.8739 14.8408C51.2926 14.5836 50.4098 14.2407 49.6992 13.4047C49.3763 13.0189 49.1179 12.5687 48.9672 12.0972C48.7734 11.5399 48.6873 10.9397 48.7088 10.3395C48.7088 9.52499 48.9026 8.71046 49.2901 7.98168C49.6346 7.27432 50.6682 6.35262 50.8835 6.22401C51.1634 6.07397 51.96 5.49523 52.8213 5.30231C54.4146 4.91649 54.7591 4.87362 56.0295 4.98079C58.807 5.21657 61.4339 6.43836 62.1229 7.05998C61.6922 7.78876 60.6587 9.54642 60.6587 9.54642C59.9051 9.1606 58.7855 8.43181 56.8692 8.00311C55.7926 7.76733 54.0271 7.78876 52.9935 8.60329C52.5414 9.01055 52.283 9.54642 52.2184 10.1466C52.2184 10.7468 52.3691 11.3255 53.5103 11.99C53.8979 12.2258 58.7424 13.4047 59.7544 13.8548C61.5415 14.6479 62.3812 15.5268 62.9411 16.7485C63.1564 17.3273 63.264 17.9489 63.221 18.592Z",
    fill: "url(#paint5_linear_1552_58263)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3141 27.3937L9.43127 28.9156H7.92407L8.80686 27.3937H10.3141Z",
    fill: "url(#paint6_linear_1552_58263)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4143 27.3937L12.51 28.9156H11.0028L11.9071 27.3937H13.4143Z",
    fill: "url(#paint7_linear_1552_58263)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.515 27.3937L15.6107 28.9156H14.1035L15.0078 27.3937H16.515Z",
    fill: "url(#paint8_linear_1552_58263)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7328 23.5569L17.85 25.1003H16.3428L17.2256 23.5569H18.7328Z",
    fill: "url(#paint9_linear_1552_58263)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.929 19.7415L20.0247 21.2634H18.5175L19.4218 19.7415H20.929Z",
    fill: "url(#paint10_linear_1552_58263)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6322 23.5569L14.7494 25.1003H13.2422L14.125 23.5569H15.6322Z",
    fill: "url(#paint11_linear_1552_58263)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5964 1.52188L31.5008 0H33.008L32.1036 1.52188H30.5964Z",
    fill: "url(#paint12_linear_1552_58263)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4958 1.52188L28.4002 0H29.9074L29.003 1.52188H27.4958Z",
    fill: "url(#paint13_linear_1552_58263)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4171 1.52188L25.2999 0H26.8071L25.9028 1.52188H24.4171Z",
    fill: "url(#paint14_linear_1552_58263)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1777 5.35868L23.0821 3.81537H24.5893L23.6849 5.35868H22.1777Z",
    fill: "url(#paint15_linear_1552_58263)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0032 9.1741L20.886 7.65222H22.3932L21.5104 9.1741H20.0032Z",
    fill: "url(#paint16_linear_1552_58263)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2783 5.35868L26.1826 3.81537H27.6898L26.7855 5.35868H25.2783Z",
    fill: "url(#paint17_linear_1552_58263)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7473 26.2149C32.8789 26.2149 32.5775 28.9157 30.7473 28.9157H17.2256L18.1084 27.3723H20.0247L20.7783 26.1934L30.7473 26.2149Z",
    fill: "url(#paint18_linear_1552_58263)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8073 22.378C37.9174 22.378 37.7021 25.0788 35.8073 25.0788H19.4435L20.3263 23.5355H23.2761L23.9435 22.378H35.8073Z",
    fill: "url(#paint19_linear_1552_58263)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9076 18.5626C41.0177 18.5626 40.8023 21.2634 38.9076 21.2634H21.6394L22.5222 19.72H27.0223L27.6897 18.5626H38.9076Z",
    fill: "url(#paint20_linear_1552_58263)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58204 15.3259C7.85953 15.3259 7.57962 18.0482 9.58204 18.0267H14.8142L15.5462 16.8264H22.5655L23.4267 15.3045L9.58204 15.3259Z",
    fill: "url(#paint21_linear_1552_58263)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9364 16.8692C37.9604 16.8477 37.6374 14.2113 35.9149 14.1898H28.4005L27.733 15.3259H25.1277L24.1803 16.8692H35.9364Z",
    fill: "url(#paint22_linear_1552_58263)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9956 11.4677H20.1752L19.2279 12.9896H13.1991L12.467 14.1899H4.9956C3.01471 14.2114 3.20849 11.4463 4.9956 11.4677Z",
    fill: "url(#paint23_linear_1552_58263)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7259 13.0109C32.6853 12.9895 32.47 10.3315 30.7044 10.3315H25.4507L24.7833 11.4676H21.7258L20.843 13.0109H30.7259Z",
    fill: "url(#paint24_linear_1552_58263)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0029 10.3531C-0.107178 10.3531 0.108136 7.63086 2.0029 7.63086H19.2711L18.3668 9.17417H13.8882L13.1992 10.3531H2.0029Z",
    fill: "url(#paint25_linear_1552_58263)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10349 6.5376C2.99341 6.5376 3.20872 3.81537 5.10349 3.81537H21.4889L20.6061 5.35868H17.6348L16.9673 6.5376H5.10349Z",
    fill: "url(#paint26_linear_1552_58263)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1635 2.7008C8.03186 2.7008 8.3333 0 10.1635 0H23.6852L22.8024 1.54331H20.8861L20.1325 2.7008H10.1635Z",
    fill: "url(#paint27_linear_1552_58263)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1552_58263",
    x1: 144.76,
    y1: 14.5836,
    x2: 160.478,
    y2: 14.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94508F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#553D68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1552_58263",
    x1: 127.535,
    y1: 14.5836,
    x2: 141.531,
    y2: 14.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B25597"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1552_58263",
    x1: 107.08,
    y1: 14.5835,
    x2: 121.614,
    y2: 14.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1552_58263",
    x1: 85.7643,
    y1: 14.5836,
    x2: 103.205,
    y2: 14.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6A3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CCF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1552_58263",
    x1: 67.4627,
    y1: 14.5836,
    x2: 81.6734,
    y2: 14.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D165B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1552_58263",
    x1: 47.1155,
    y1: 15.441,
    x2: 64.0176,
    y2: 15.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD4D9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1552_58263",
    x1: 8.35891,
    y1: 28.0797,
    x2: 9.8661,
    y2: 28.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#845D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1552_58263",
    x1: 11.481,
    y1: 28.0797,
    x2: 13.0958,
    y2: 28.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#916589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A66492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1552_58263",
    x1: 14.6031,
    y1: 28.0797,
    x2: 16.1103,
    y2: 28.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA678C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1552_58263",
    x1: 16.7562,
    y1: 24.2214,
    x2: 18.2634,
    y2: 24.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A988A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4839E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1552_58263",
    x1: 19.1247,
    y1: 20.256,
    x2: 20.4159,
    y2: 20.5802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C793B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C29BB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1552_58263",
    x1: 13.7418,
    y1: 24.2214,
    x2: 15.249,
    y2: 24.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967590"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1552_58263",
    x1: 31.0746,
    y1: 0.643047,
    x2: 32.7971,
    y2: 0.643047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CAEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1552_58263",
    x1: 28.0602,
    y1: 0.321523,
    x2: 29.4581,
    y2: 0.861604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AB1B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1552_58263",
    x1: 24.8305,
    y1: 0.643047,
    x2: 26.4454,
    y2: 0.643047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74ACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1552_58263",
    x1: 22.6773,
    y1: 4.50133,
    x2: 24.1845,
    y2: 4.50133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBAC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1552_58263",
    x1: 20.5242,
    y1: 8.35964,
    x2: 22.0314,
    y2: 8.35964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC6DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1552_58263",
    x1: 25.7994,
    y1: 4.50133,
    x2: 27.3066,
    y2: 4.50133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84BAB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FC2C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1552_58263",
    x1: 18.0482,
    y1: 27.651,
    x2: 32.1512,
    y2: 27.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9BE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C570A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1552_58263",
    x1: 20.2013,
    y1: 23.7927,
    x2: 37.9647,
    y2: 23.7927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426554,
    stopColor: "#DF9EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1552_58263",
    x1: 22.2467,
    y1: 19.9344,
    x2: 39.6871,
    y2: 19.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9EBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1552_58263",
    x1: 8.25135,
    y1: 16.7192,
    x2: 22.3544,
    y2: 16.7192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B5D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#DC6DB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B597B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1552_58263",
    x1: 24.7228,
    y1: 15.8618,
    x2: 37.6416,
    y2: 15.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1552_58263",
    x1: 3.51438,
    y1: 12.861,
    x2: 19.6629,
    y2: 12.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA58A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A8CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1552_58263",
    x1: 21.3855,
    y1: 11.5748,
    x2: 32.1512,
    y2: 11.5748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4ACCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1552_58263",
    x1: 0.5,
    y1: 9.00267,
    x2: 18.3711,
    y2: 9.00267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF5AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D391C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1552_58263",
    x1: 3.51438,
    y1: 5.14438,
    x2: 21.3854,
    y2: 5.14438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D077AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FE93D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1552_58263",
    x1: 8.68197,
    y1: 1.28609,
    x2: 23.7539,
    y2: 1.28609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B7A2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBBC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.63c5d0523390dfa91704c3a56d5b5100.svg";
export { ForwardRef as ReactComponent };